import styled from 'styled-components';
import { media, customMedia } from 'styles/utils';
import { Button, Paragraph } from 'components';

export const ContainerInfo = styled.div`
  text-align: ${props => props.align && props.align};
  margin-top: ${props => props.theme.spacing.large};
  /* Media queries */
  ${media.large`
    padding: 0 10%;
  `}
`;

export const List = styled.ul`
  margin: ${props => props.theme.spacing.large} 0;
  color: ${props => props.theme.color.wfGrey900};
  > li {
    margin-bottom: ${props => props.theme.spacing.default};
    svg {
      margin-right: ${props => props.theme.spacing.default};
    }
  }
`;

export const ParagraphStyled = styled(Paragraph)`
  /* TODO: Explore the possibility to include this rule generic inside Paragraph component */
  > a {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
    font-size: ${props => props.theme.font.size.small};
  }
`;

// FIXME: replace by ContButtons from shared components in manufacturing
export const ContButtons = styled.nav`
  margin-top: ${props => props.theme.spacing.large};
`;

export const ButtonStyled = styled(Button)`
  margin: ${props => props.theme.spacing.small} 0;
  /* Media queries */
  ${customMedia.lessThan('medium')`
    width: 100%;
  `}
  ${media.medium`
    margin: ${props => props.theme.spacing.small};
  `}
`;
